'use strict';

var isTwelveHourTime = require('./is-twelve-hour-time');
module.exports = function stringify(groups) {
  if (isTwelveHourTime(groups)) return groups.slice(0, -1).join(':') + ' ' + groups[groups.length - 1];
  return groups.join(':');
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/stringify.js
// module id = 1724
// module chunks = 0